import React from 'react';
import { TableRowProps } from '../../../types';
import './TableRow.css';

const TableRow: React.FC<TableRowProps> = ({
  children,
  onClick,
  isHeader = false,
  className = ''
}) => {
  const rowClasses = `table-row ${isHeader ? 'table-header-row' : ''} ${onClick ? 'clickable' : ''} ${className}`.trim();
  
  return (
    <div className={rowClasses} onClick={onClick}>
      {children}
    </div>
  );
};

export default TableRow;
